import { Action } from '@ngrx/store';
import { RouterStateSnapshot } from '@angular/router';
import { RouterNavigationAction } from '@ngrx/router-store';

import { DictionaryListDto, ICountryStatesDto,
  SubscribableEditionComboboxItemDto, LookupDto } from '@shared/service-proxies/service-proxies';

export const FAKE_ACTION = '[Root] Fake Action';
export const ERROR_NOTIFY_ACTION = '[Root] Error notify action';
export const LOCALISATION_CHANGED = '[Root] Localisation changed'; // handle to change phoneMask for example
export const INIT_STATES = '[Root] Init states';
export const LOAD_STATES = '[Root] Load states';
export const STATES_LOADED = '[Root] States loaded';
export const LOAD_ACCOUNT_TYPES = '[Root] Loaded account types';
export const ACCOUNT_TYPES_LOADED = '[Root] Account types loaded';
export const LOAD_GEOGRAPHIC_REGIONS = '[Root] Loaded geographic regions';
export const GEOGRAPHIC_REGIONS_LOADED = '[Root] Geographic regions loaded';
export const LOAD_INDUSTRY_TYPES = '[Root] Loaded industry types';
export const INDUSTRY_TYPES_LOADED = '[Root] Industry types loaded';
export const INIT_TRANSACTION_TYPES = '[Root] Init transaction types';
export const LOAD_TRANSACTION_TYPES = '[Root] Load transaction types';
export const TRANSACTION_TYPES_LOADED = '[Root] Transaction types loaded';
export const INIT_UNITS_OF_MEASURE = '[Root] Init units of measure';
export const LOAD_UNITS_OF_MEASURE = '[Root] Load units of measure';
export const LOAD_UNITS_OF_MEASURE_SUCCEEDED = '[Root] Load units of measure succeeded';
export const INIT_CUSTOMER_TYPES = '[Root] Init customer types';
export const LOAD_CUSTOMER_TYPES = '[Root] Load customer types';
export const LOAD_CUSTOMER_TYPES_SUCCEEDED = '[Root] Load customer types succeeded';
export const INIT_SUFFIXES = '[Root] Init suffixes';
export const LOAD_SUFFIXES = '[Root] Load suffixes';
export const LOAD_SUFFIXES_SUCCEEDED = '[Root] Load suffixes succeeded';
export const LOAD_EDITIONS = '[Root] Load editions';
export const EDITIONS_LOADED = '[Root] Editions loaded';
export const HANDLE_TRANSACTION_UPDATING_FAILD_EVENT = '[Root] Handle transaction updating faild event';
export const LOAD_FREQUENCY_OPTIONS = '[Root] Load frequency options';
export const FREQUENCY_OPTIONS_LOADED = '[Root] Frequency options loaded';
export const ADD_CORRELATION_ID_IN_PAGE_STATE = '[Root] Add correlation id in page state';
export const CLEAR_CORRELATION_IDS_IN_PAGE_STATE = '[Root] Clear correlation ids in page state';

export interface TransactionRemovingFaildPayload {
  userId: number;
  tenantId: number;
  message: string;
  transactionId: number;
}

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */

export class NotifyErrorAction implements Action {
  readonly type = ERROR_NOTIFY_ACTION;

  constructor(public payload: string) {}
}

export class LocalisationChangedAction implements Action {
  readonly type = LOCALISATION_CHANGED;

  constructor(public payload: string) {}
}

export class InitStatesAction implements Action {
  readonly type = INIT_STATES;

  constructor() {}
}

export class LoadStatesAction implements Action {
  readonly type = LOAD_STATES;

  constructor() {}
}

export class StatesLoadedAction implements Action {
  readonly type = STATES_LOADED;

  constructor(public payload: ICountryStatesDto[]) {}
}

export class LoadAccountTypesAction implements Action {
  readonly type = LOAD_ACCOUNT_TYPES;

  constructor() {}
}

export class AccountTypesLoadedAction implements Action {
  readonly type = ACCOUNT_TYPES_LOADED;

  constructor(public payload: DictionaryListDto[]) {}
}

export class LoadGeographicRegionsAction implements Action {
  readonly type = LOAD_GEOGRAPHIC_REGIONS;

  constructor() {}
}

export class GeographicRegionsLoadedAction implements Action {
  readonly type = GEOGRAPHIC_REGIONS_LOADED;

  constructor(public payload: DictionaryListDto[]) {}
}

export class LoadIndustryTypesAction implements Action {
  readonly type = LOAD_INDUSTRY_TYPES;

  constructor() {}
}

export class IndustryTypesLoadedAction implements Action {
  readonly type = INDUSTRY_TYPES_LOADED;

  constructor(public payload: DictionaryListDto[]) {}
}

export class InitTransactionTypesAction implements Action {
  readonly type = INIT_TRANSACTION_TYPES;

  constructor() {}
}

export class LoadTransactionTypesAction implements Action {
  readonly type = LOAD_TRANSACTION_TYPES;

  constructor() {}
}

export class TransactionTypesLoadedAction implements Action {
  readonly type = TRANSACTION_TYPES_LOADED;

  constructor(public payload: string[]) {}
}

export class InitUnitsOfMeasureAction implements Action {
  readonly type = INIT_UNITS_OF_MEASURE;

  constructor() {}
}

export class LoadUnitsOfMeasureAction implements Action {
  readonly type = LOAD_UNITS_OF_MEASURE;

  constructor() {}
}

export class LoadUnitsOfMeasureSucceededAction implements Action {
  readonly type = LOAD_UNITS_OF_MEASURE_SUCCEEDED;

  constructor(public payload: string[]) {}
}

export class InitCustomerTypesAction implements Action {
  readonly type = INIT_CUSTOMER_TYPES;

  constructor() {}
}

export class LoadCustomerTypesAction implements Action {
  readonly type = LOAD_CUSTOMER_TYPES;

  constructor() {}
}

export class LoadCustomerTypesSucceededAction implements Action {
  readonly type = LOAD_CUSTOMER_TYPES_SUCCEEDED;

  constructor(public payload: string[]) {}
}

export class InitSuffixesAction implements Action {
  readonly type = INIT_SUFFIXES;

  constructor() {}
}

export class LoadSuffixesAction implements Action {
  readonly type = LOAD_SUFFIXES;

  constructor() {}
}

export class LoadSuffixesSucceededAction implements Action {
  readonly type = LOAD_SUFFIXES_SUCCEEDED;

  constructor(public payload: string[]) {}
}

export class LoadEditionsAction implements Action {
  readonly type = LOAD_EDITIONS;

  constructor() {}
}

export class EditionsLoadedAction implements Action {
  readonly type = EDITIONS_LOADED;

  constructor(public payload: SubscribableEditionComboboxItemDto[]) {}
}

export class LoadFrequencyOptionsAction implements Action {
  readonly type = LOAD_FREQUENCY_OPTIONS;

  constructor() {}
}

export class FrequencyOptionsLoadedAction implements Action {
  readonly type = FREQUENCY_OPTIONS_LOADED;

  constructor(public payload: LookupDto[]) {}
}

export class AddCorrelationIdInPageStateAction implements Action {
  readonly type = ADD_CORRELATION_ID_IN_PAGE_STATE;

  constructor(public correlationId: string) {}
}

export class ClearCorrelationIdsInPageStateAction implements Action {
  readonly type = CLEAR_CORRELATION_IDS_IN_PAGE_STATE;

  constructor() {}
}


/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    NotifyErrorAction
    | LocalisationChangedAction
    | RouterNavigationAction<RouterStateSnapshot>
    | InitStatesAction
    | LoadStatesAction
    | StatesLoadedAction
    | LoadAccountTypesAction
    | AccountTypesLoadedAction
    | LoadGeographicRegionsAction
    | GeographicRegionsLoadedAction
    | LoadIndustryTypesAction
    | IndustryTypesLoadedAction
    | InitTransactionTypesAction
    | LoadTransactionTypesAction
    | TransactionTypesLoadedAction
    | InitUnitsOfMeasureAction
    | LoadUnitsOfMeasureAction
    | LoadUnitsOfMeasureSucceededAction
    | InitCustomerTypesAction
    | LoadCustomerTypesAction
    | LoadCustomerTypesSucceededAction
    | InitSuffixesAction
    | LoadSuffixesAction
    | LoadSuffixesSucceededAction
    | LoadEditionsAction
    | EditionsLoadedAction
    | LoadFrequencyOptionsAction
    | FrequencyOptionsLoadedAction
    | AddCorrelationIdInPageStateAction
    | ClearCorrelationIdsInPageStateAction;
